import { branch, renderComponent } from 'recompose';
import Loader from '../../UI/Loader';

// These funcs decorate another component and won't render the inner component
// unless the func passed as `isLoading` is truthy

const indicateWhenLoading = isLoading =>
  branch(isLoading, renderComponent(Loader));

export const vehicleListEnhancer = indicateWhenLoading(
  props => props.loadingVehicles
);

export const paymentMethodListEnhancer = indicateWhenLoading(
  props => props.loadingPaymentMethods
);
